module.exports = "/_next/static/images/42b3eedb13bdcfa63443cc4431f8fe54-incoming-call-icon.svg.webp";